import {User as FirebaseUser} from 'firebase/auth'

export interface IAuthUser {
  isComplete?: boolean;
  email?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  postalCode?: string;
  dob?: string;
  termsAcceptedOn?: string;
  mobileNumber?: string;
  country?: string;
  confirmPassword?: string;
  surveyUpdatedOn?: number;
  countryCode?: string;
}

export interface ValidationStatus {
  status: 'warning' | 'error';
  description?: string;
}

export type UserValidationErrors = Record<keyof IAuthUser, ValidationStatus>;


class User implements IAuthUser {
  constructor(private authUser: FirebaseUser | null) {}

  public get hasVerifiedEmail(): boolean {
    return this.authUser?.emailVerified ?? false;
  }

  public get email(): string {
    return this.authUser?.email ?? '';
  }

  public get name(): string {
    return this.authUser?.displayName ?? '';
  }

  public get uid(): string {
    return this.authUser?.uid ?? '';
  }

  public get photoURL(): string {
    return this.authUser?.photoURL ?? '';
  }

  public get isSignedIn(): boolean {
    return !!this.authUser;
  }

  public clone(): User {
    return new User(this.authUser);
  }

  public get firstName() {
    if (!this.name) {
      return '';
    }
    return this.name.split(' ')[0];
  }

  public get lastName() {
    if (!this.name) {
      return '';
    }
    return this.name.split(' ')[1];
  }
}

export interface IListPreviewInfo {
  id: string;

  // Name of the list.
  name: string;

  // Total number of items in this list.
  count: number;

  // The content id of which we are using the image.
  // This id will be compared when the content is deleted from list, so that we can remove the image (and may be use some other image).
  previewContentId?: string;

  // The URL of the image.
  image?: string;
}

export type PlanSource = Pick<IListPreviewInfo, 'id' | 'name'> &
  Partial<IListPreviewInfo>;

export interface ISummary {
  // Total items in this user's wishlist.
  wishlist: IListPreviewInfo;

  // Similar to wishlist but made up of dynamic list names.
  plans: Record<string, IListPreviewInfo>;
}

export interface IProfile extends Omit<IAuthUser, 'isComplete' | 'password'> {
  stripeId: string;
  subscription?: {
    title: string;
    // Stripe id of the subscription.
    planStripeId?: string;
    planCmsId?: string;
    // The id of current subscription.
    id?: string;
  };
  summary: ISummary;
}


export default User;
